// extracted by mini-css-extract-plugin
export default {"avatar":"of8Arz"};